<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.report.text") }}</h1>

      <div role="tablist">
        <b-card no-body class=" shadow-none mb-3">
          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.report.line-1") }}
            </p>

            <p class="mb-3">{{ $t("help.platform.report.line-2") }}</p>
            <img src="@/assets/images/help/report.png" class="image" />
            <p class="mb-3 mt-3">{{ $t("help.platform.report.line-2") }}</p>
            <p class="mb-3 mt-3">{{ $t("help.platform.report.line-3") }}</p>
            <p class="mb-3 mt-3">{{ $t("help.platform.report.line-4") }}</p>
            <p class="mb-3 mt-3">{{ $t("help.platform.report.line-5") }}</p>
            <img src="@/assets/images/help/file-upload-modal.png" class="image" />
            <p class="mb-3 mt-3">{{ $t("help.platform.report.line-6") }}</p>
            <a class="mt-3" href="/kvkk/report">
              <p><i class="bx bx-support"></i> {{ $t("help.platform.report.line-7") }}</p>
            </a>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
